"use client";

import TranslationFriendlyLink from "@/components/TranslationFriendlyLink";
import { usePathname } from "next/navigation";
// import { useEffect, useRef } from "react";
// import { translationToolDetected } from "@/state";

const topNavLinks = [
    { label: "EC2", href: "/" },
    { label: "RDS", href: "/rds" },
    { label: "ElastiCache", href: "/elasticache" },
    { label: "Redshift", href: "/redshift" },
    { label: "OpenSearch", href: "/opensearch" },
    { label: "Azure", href: "/azure" },
    { label: "GCP", href: "/gcp" },
];

function isNavActive(pathname: string, href: string) {
    if (href === "/") {
        return pathname === "/" || pathname.startsWith("/aws/ec2/");
    }
    if (href === "/elasticache") {
        return (
            pathname === href ||
            pathname.startsWith(`${href}/`) ||
            pathname.startsWith("/aws/elasticache/")
        );
    }
    if (["/rds", "/redshift", "/opensearch"].includes(href)) {
        return (
            pathname === href ||
            pathname.startsWith(`${href}/`) ||
            pathname.startsWith(`/aws${href}/`)
        );
    }
    return pathname === href || pathname.startsWith(`${href}/`);
}

// function TranslationToolDetector({
//     className,
//     text,
// }: {
//     className: string;
//     text: string;
// }) {
//     const spanRef = useRef<HTMLSpanElement>(null);

//     useEffect(() => {
//         const span = spanRef.current;
//         if (!span) return;

//         const observer = new MutationObserver((mutations) => {
//             mutations.forEach((mutation) => {
//                 const textContent = mutation.target.textContent;
//                 if (textContent !== text) {
//                     translationToolDetected.set(true);
//                     observer.disconnect();
//                 }
//             });
//         });
//         observer.observe(span, { childList: true });
//         return () => observer.disconnect();
//     }, [text]);

//     return (
//         <span ref={spanRef} className={className}>
//             {text}
//         </span>
//     );
// }

export default function TopNav() {
    const currentPath = usePathname();

    return (
        <nav className="bg-gray-100 border-b border-gray-200">
            <div className="flex items-center justify-between h-[3rem] px-4">
                {/* Left: Logo + Nav Tabs */}
                <div className="flex items-center space-x-4">
                    {/* Logo */}
                    <TranslationFriendlyLink
                        href="https://bigbell.ai"
                        className="flex items-center gap-2"
                    >
                        <img
                            src="/coin/Logo.svg"
                            alt="BigBell"
                            className="h-8"
                        />
                    </TranslationFriendlyLink>

                    {/* Tab Navigation */}
                    <div className="flex space-x-1">
                        {topNavLinks.map(({ label, href }) => {
                            const isActive = isNavActive(currentPath, href);
                            return (
                                <TranslationFriendlyLink
                                    key={label}
                                    href={href}
                                    aria-current={isActive ? "page" : undefined}
                                    className={`px-4 py-1 rounded-t text-sm font-medium transition ${
                                        isActive
                                            ? "bg-white shadow text-black"
                                            : "text-gray-600 hover:bg-gray-200"
                                    }`}
                                >
                                    {label}
                                </TranslationFriendlyLink>
                            );
                        })}
                    </div>
                </div>
            </div>
        </nav>
    );
}
